<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>勢能-About</h2>
            <h2 style="padding-top: 10px;">關於碩達</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<section class="about-area ptb-100">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content:space-evenly;">
            <div class="content">
                <h3 style="color: #2781bd;">Order out of Chaos<br>生於混沌，存於有序</h3>
                <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p>
            </div>
            <img class="pic1" src="assets/img/about/pic_01.jpg" alt="image">
        </div>

        <!-- <div class="about-inner-area">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Our History</h3>
                        <p>Lorem ipsum dolor sit amet, con se ctetur adipiscing elit. In sagittis eg esta ante, sed viverra nunc tinci dunt nec elei fend et tiram.</p>

                        <i class="flaticon-house"></i>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Our Mission</h3>
                        <p>Lorem ipsum dolor sit amet, con se ctetur adipiscing elit. In sagittis eg esta ante, sed viverra nunc tinci dunt nec elei fend et tiram.</p>

                        <i class="flaticon-insurance"></i>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                    <div class="about-text">
                        <h3>Who we are</h3>
                        <p>Lorem ipsum dolor sit amet, con se ctetur adipiscing elit. In sagittis eg esta ante, sed viverra nunc tinci dunt nec elei fend et tiram.</p>

                        <i class="flaticon-box"></i>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</section>
<!-- End About Area -->

<!-- Start Features Area -->
<section class="features-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content: space-evenly;padding-bottom: 110px;margin-bottom: 0px;">
            <div style="padding-bottom: 15px;">
                <img src="assets/img/about/pic_02.jpg" alt="image">
            </div>

            <div class="content">
                <h3 style="color: #2781bd;">共能碩力</h3>
                <p style="color: black;">碩達系統集結各領域專家，超過 20 年以上資訊資歷，兼具軟硬體整合能力，擁有跨產業經驗以及大型專案規劃導入與執行能力，專注細節強調企業適用性，以嚴謹審慎的態度對待每一個專案，提供企業即戰力。</p>

                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> 專業顧問團隊</span></li>
                    <li><span><i class='bx bx-check-double'></i> 軟硬體解決方案整合</span></li>
                    <li><span><i class='bx bx-check-double'></i> 產官學合作</span></li>
                    <li><span><i class='bx bx-check-double'></i> 企業轉型諮詢</span></li>
                    <li><span><i class='bx bx-check-double'></i> 旗艦級專案導入</span></li>
                </ul>
            </div>
        </div>

        <div class="overview-box" style="justify-content: space-evenly;">
            <div class="content">
                <h3 style="color: #2781bd;">捷誠必達</h3>
                <p style="color: black;"><span style="font-weight: 700;">跨越 0-1 的距離</span> 「複製模型比創新容易。從已知的事開始做，是世界從 1 變到 n，添加更多熟悉的東西。但是，創建新事物時，我們是從 0 到 1，這過程獨一無二，結果也是新奇的。」by Peter Thiel, Blake Masters </p>
                <p style="color: black;">碩達希望透過專業的洞察力，在技術之間架起橋樑，結合現有與新興技術，協同企業驗證每一個奇思妙想，安穩創建達到下一個十年為目標。 </p>

                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> Design Thinking</span></li>
                    <li><span><i class='bx bx-check-double'></i> Agile</span></li>
                    <li><span><i class='bx bx-check-double'></i> Devops</span></li>
                    <li><span><i class='bx bx-check-double'></i> Automation</span></li>
                    <li><span><i class='bx bx-check-double'></i> AIOT/AI</span></li>
                    <li><span><i class='bx bx-check-double'></i> CICD</span></li>
                </ul>
            </div>

            <img class="pic1" src="assets/img/about/pic_11.jpg" alt="image">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img class="pic3" src="assets/img/about/pic_03.jpg" alt="image">
            </div> -->
        </div>
    </div>

    <!-- <div class="rectangle-shape1"><img src="assets/img/rectangle-shape1.png" alt="image"></div>
    <div class="rectangle-shape2"><img src="assets/img/rectangle-shape2.png" alt="image"></div> -->
</section>
<!-- End Features Area -->

<!-- Start Team Area -->
<section class="team-area ptb-100 pb-0">
    <div class="container" style="max-width: 100%;">
        <div class="section-title">
            <h2 style="font-size: 35px;">公司組織</h2>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> -->
        </div>
        <div style="text-align: center;">
            <img src="assets/img/about/pic_04.png " class="pic4">
        </div>
    </div>

    <!-- <div class="row" style="justify-content:center"> -->
    <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/1.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>John Smith</h3>
                        <span>Web Developer</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/2.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>Lucy Eva</h3>
                        <span>Manager</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/3.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>Steven Smith</h3>
                        <span>Web Developer</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team/4.jpg" alt="team">

                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div class="content">
                        <h3>Sarah Taylor</h3>
                        <span>Desginer</span>
                    </div>
                </div>
            </div> -->
    <!-- </div> -->

    <div class="container" style="max-width: 90%;">
        <div class="overview-box ptb-100" style="justify-content: space-evenly;">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/about/pic_05.jpg" alt="image" style="max-width: 60%;">
            </div> -->
            <img src="assets/img/about/pic_05.jpg" class="pic5" alt="image">

            <div class="content">
                <h3 style="color: #2781bd;">善動世界 Move to Good</h3>
                <h3 style="color: #2781bd;">CSR 企業社會責任</h3>
                <p style="font-size: 18px;color: black;">一隻蝴蝶翅膀的搧動可能帶給地球另一端連鎖的反應，一個微不足道的動作，或許會改變人的一生；我們始終相信再微小的光也會成為黑暗中的指引，從己身出發量力而為，以善為始，不以得終，透過正向的力量，希望能藉由每一次推廣與參與，在時間的長廊上留下一點感動的記憶。 </p>
            </div>
        </div>
    </div>

</section>
<!-- End Team Area -->

<!-- <app-subscribe></app-subscribe> -->